/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/member-ordering */
import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Chart, registerables } from "chart.js";
import { FetchData } from "app/shared/generalMethods";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";

interface CalendarDay {
  date: Date;
  day: number;
  isCurrentMonth: boolean;
  isToday: boolean;
  hasSessions: boolean;
  sessionCount: number;
  remark?: string;
  color?: string;
}

@Component({
  selector: "app-admin-dashboard",
  templateUrl: "./admin-dashboard.component.html",
  styleUrls: ["./admin-dashboard.component.scss"],
})
export class AdminDashboardComponent implements OnInit, AfterViewInit {
  @ViewChild("programChart") programChartRef: any;
  @ViewChild("attendanceChart") attendanceChartRef: any;
  @ViewChild("paymentsChart") paymentsChartRef: any;

  pageLoader = false;
  pageLoaderText = "Loading dashboard...";

  // Calendar variables
  currentDate: Date = new Date();
  currentMonth: number = this.currentDate.getMonth();
  currentYear: number = this.currentDate.getFullYear();
  weeks: any[] = [];
  monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  remarks: { [key: string]: { text: string; color: string } } = {};
  selectedDay: Date | null = null;
  remarkText: string = "";
  remarkColor: string = "#7cbd4a"; // Default color
  colorOptions = [
    "#3f51b5",
    "#e91e63",
    "#4caf50",
    "#ff9800",
    "#607d8b",
    "#9c27b0",
  ];

  lstClassSchedules: any[] = [];
  lstPrograms: any[] = [];
  lstLocations: any[] = [];
  lstCategories: any[] = []; // Added categories array
  lstRegistrationSchedules: any[] = [];
  currentAdminId: string = "";
  currentAdminName: any[] = [];
  lstAttendance: any[] = [];
  isAdmin: boolean = false;

  // Statistics data
  stats = {
    totalPrograms: 0,
    programsGrowth: 0,
    totalStudents: 0,
    studentsGrowth: 0,
    totalCommunities: 0,
    communitiesGrowth: 0,
    activeSessions: 0,
    sessionsToday: 0,
    programDistribution: [] as { program: string; count: number }[],
  };

  // Upcoming classes table
  upcomingClasses: any[] = [];
  scheduleColumns = ["program", "instructor", "students", "status"];

  // Recent programs table
  recentPrograms: any[] = [];
  programColumns = ["name", "type", "location", "participants"];

  // Attendance stats
  attendanceStats = {
    todayPresent: 0,
    todayTotal: 0,
    todayPercentage: 0,
    monthlyAverage: 0,
    weeklyTrend: [] as number[],
  };

  // Payment stats - FIXED: Added proper initialization
  paymentStats = {
    monthlyTotal: 0,
    outstanding: 0,
    monthlyTrend: [] as number[],
  };

  constructor(
    private _fetchData: FetchData,
    private _router: Router,
    private _snackBar: MatSnackBar
  ) {
    Chart.register(...registerables);
  }

  ngOnInit(): void {
    this.loadDashboardData();
    this.generateCalendar();
  }

  canViewPrograms(): boolean {
    return this.isAdmin || this.checkPermission("programs", "view");
  }

  canViewAttendance(): boolean {
    return this.isAdmin || this.checkPermission("attendance", "view");
  }

  canViewReports(): boolean {
    return this.isAdmin || this.checkPermission("reports", "view");
  }

  canViewDashboard(): boolean {
    const isAdmin =
      (this._fetchData.data?.lstAdministratorData || []).length > 0;
    if (isAdmin) return true;
    return this.checkPermission("dashboard", "view");
  }

  ngAfterViewInit(): void {
    // Charts will be created after data is processed
  }

  openDayRemark(day: Date): void {
    this.selectedDay = day;
    const dateKey = this.getDateKey(day);
    if (this.remarks[dateKey]) {
      this.remarkText = this.remarks[dateKey].text;
      this.remarkColor = this.remarks[dateKey].color;
    } else {
      this.remarkText = "";
      this.remarkColor = "#3f51b5";
    }
  }

  saveRemark(): void {
    if (this.selectedDay) {
      const dateKey = this.getDateKey(this.selectedDay);
      if (this.remarkText.trim()) {
        this.remarks[dateKey] = {
          text: this.remarkText,
          color: this.remarkColor,
        };
      } else {
        delete this.remarks[dateKey];
      }
      this.generateCalendar();
      this.selectedDay = null;
    }
  }

  cancelRemark(): void {
    this.selectedDay = null;
  }

  getDateKey(date: Date): string {
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
  }

  generateCalendar(): void {
    this.weeks = [];
    const firstDay = new Date(this.currentYear, this.currentMonth, 1);
    const lastDay = new Date(this.currentYear, this.currentMonth + 1, 0);

    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - startDate.getDay());

    const endDate = new Date(lastDay);
    endDate.setDate(endDate.getDate() + (6 - endDate.getDay()));

    const currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const week: CalendarDay[] = [];

      for (let i = 0; i < 7; i++) {
        const day = new Date(currentDate);
        const sessions = this.getSessionsForDay(day);
        const dateKey = this.getDateKey(day);
        const remark = this.remarks[dateKey];

        week.push({
          date: day,
          day: day.getDate(),
          isCurrentMonth: day.getMonth() === this.currentMonth,
          isToday: this.isSameDay(day, new Date()),
          hasSessions: sessions.length > 0,
          sessionCount: sessions.length,
          remark: remark?.text,
          color: remark?.color,
        });

        currentDate.setDate(currentDate.getDate() + 1);
      }

      this.weeks.push(week);
    }
  }

  getSessionsForDay(day: Date): any[] {
    return this.lstClassSchedules.filter((schedule) => {
      const sessionDate = new Date(schedule.Date__c);
      return this.isSameDay(sessionDate, day);
    });
  }

  isSameDay(date1: Date, date2: Date): boolean {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  }

  prevMonth(): void {
    this.currentMonth--;
    if (this.currentMonth < 0) {
      this.currentMonth = 11;
      this.currentYear--;
    }
    this.generateCalendar();
  }

  nextMonth(): void {
    this.currentMonth++;
    if (this.currentMonth > 11) {
      this.currentMonth = 0;
      this.currentYear++;
    }
    this.generateCalendar();
  }

  goToToday(): void {
    this.currentDate = new Date();
    this.currentMonth = this.currentDate.getMonth();
    this.currentYear = this.currentDate.getFullYear();
    this.generateCalendar();
  }

  loadDashboardData(): void {
    this.pageLoader = true;
    if (!this.canViewDashboard()) {
      this.pageLoader = false;
      return;
    }

    // Get the current administrator and staff data
    const lstAdminData = this._fetchData.data?.lstAdministratorData || [];
    const lstStaffData = this._fetchData.data?.lstStaffData || [];
    const countAdmin = lstAdminData.length;
    const countStaff = lstStaffData.length;

    // Check if staff has dashboard view permission
    const hasDashboardAccess =
      countAdmin > 0 ||
      (countStaff > 0 && this.checkPermission("dashboard", "view"));

    if (!hasDashboardAccess) {
      this.pageLoader = false;
      this._snackBar.open(
        "You do not have permission to view the dashboard",
        "OK",
        { duration: 5000 }
      );
      return;
    }

    // Get categories data
    this.lstCategories = this._fetchData.data?.lstCategories || [];

    // Get the current user ID and name based on role
    if (countAdmin === 1) {
      this.currentAdminId = lstAdminData[0]?.Id || "";
      this.currentAdminName = lstAdminData[0]?.Administrator_Name__c || "";
      this.lstLocations = this._fetchData.data?.lstLocations || [];
      this.lstPrograms = (this._fetchData.data?.lstPrograms || []).filter(
        (program) => program.Administrator__c === this.currentAdminId
      );
    } else if (countAdmin === 0 && countStaff === 1) {
      this.currentAdminId = lstStaffData[0]?.Administrator__c || "";
      this.currentAdminName = lstStaffData[0]?.Staff_Name__c || "";
      this.lstPrograms = (this._fetchData.data?.lstPrograms || []).filter(
        (program) => program.Administrator__c === this.currentAdminId
      );
      this.lstLocations = this._fetchData.data?.lstLocations || [];
    } else {
      this.lstPrograms = [];
      this.lstLocations = [];
    }

    // Get the IDs of the filtered programs
    const filteredProgramIds = this.lstPrograms.map((program) => program.Id);

    // Filter class schedules that belong to the filtered programs
    this.lstClassSchedules = (
      this._fetchData.data?.lstClassSchedules || []
    ).filter((schedule) => filteredProgramIds.includes(schedule.Program__c));

    // Get registration schedules for the filtered class schedules
    const filteredClassScheduleIds = this.lstClassSchedules.map(
      (schedule) => schedule.Id
    );
    this.lstRegistrationSchedules = (
      this._fetchData.data?.lstRegistrationSchedules || []
    ).filter((reg) => filteredClassScheduleIds.includes(reg.Class_Schedule__c));

    // Get attendance records for the filtered class schedules
    this.lstAttendance = (this._fetchData.data?.lstAttendance || []).filter(
      (attendance) =>
        filteredClassScheduleIds.includes(attendance.Class_Schedule__c)
    );

    // Process the data
    if (
      this.lstClassSchedules.length > 0 ||
      this.lstPrograms.length > 0 ||
      this.lstLocations.length > 0
    ) {
      this.processDashboardData();
      this.pageLoader = false;
      this.createCharts();
      this.generateCalendar();
    } else {
      this.pageLoader = false;
    }
  }

  checkPermission(permissionType: string, action: string): boolean {
    const lstAdminData = this._fetchData.data?.lstAdministratorData || [];
    if (lstAdminData.length > 0) return true;

    const lstStaffData = this._fetchData.data?.lstStaffData || [];
    if (lstStaffData.length === 0) return false;

    const permissionSets = lstStaffData[0]?.Permission_Sets__c;
    if (!permissionSets) return false;

    try {
      const permissions = JSON.parse(permissionSets.replace(/&quot;/g, '"'));
      return permissions[permissionType]?.[action] === true;
    } catch (e) {
      console.error("Error parsing permissions:", e);
      return false;
    }
  }

  private createCharts(): void {
    setTimeout(() => {
      this.createProgramDistributionChart();
      this.createAttendanceChart();
      this.createPaymentsChart();
    }, 100);
  }

  processDashboardData(): void {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    // 1. Total Communities (from lstLocations)
    this.stats.totalCommunities = this.lstLocations.length;

    // 2. Total Programs (from lstPrograms)
    this.stats.totalPrograms = this.lstPrograms.length;

    // 3. Total Students (count of registration schedules)
    this.stats.totalStudents = this.lstRegistrationSchedules.length;

    // 4. Recent Programs (last 4 created from lstPrograms) - UPDATED: Use Category object
    this.recentPrograms = this.lstPrograms
      .sort(
        (a, b) =>
          new Date(b.CreatedDate).getTime() - new Date(a.CreatedDate).getTime()
      )
      .slice(0, 4)
      .map((program) => {
        const programSchedules = this.lstClassSchedules.filter(
          (s) => s.Program__c === program.Id
        );

        // Calculate total registered students for this program
        const totalParticipants = programSchedules.reduce((sum, schedule) => {
          const registrations = this.lstRegistrationSchedules.filter(
            (reg) => reg.Class_Schedule__c === schedule.Id
          );
          return sum + registrations.length;
        }, 0);

        // Get category name from Category object using lookup field
        const category = this.lstCategories.find(
          (cat) => cat.Id === program.Category_of_Program__c
        );

        return {
          name: program.Name,
          type:
            category?.Name ||
            program.Category_of_Program__r.Category_Name__c ||
            "N/A", // Fallback to old field if needed
          location:
            this.lstLocations.find((l) => l.Id === program.Program_Location__c)
              ?.Name || "N/A",
          participants: totalParticipants,
          communities: this.lstLocations.filter(
            (l) => l.Id === program.Program_Location__c
          ).length,
        };
      });

    // 5. Program Distribution by Category - UPDATED: Use Category object
    const categoryDistribution = new Map<string, number>();

    this.lstPrograms.forEach((program) => {
      const category = this.lstCategories.find(
        (cat) => cat.Id === program.Category_of_Program__c
      );
      const categoryName =
        category?.Name ||
        program.Category_of_Program__r.Category_Name__c ||
        "Uncategorized";

      if (categoryDistribution.has(categoryName)) {
        categoryDistribution.set(
          categoryName,
          categoryDistribution.get(categoryName)! + 1
        );
      } else {
        categoryDistribution.set(categoryName, 1);
      }
    });

    this.stats.programDistribution = Array.from(
      categoryDistribution.entries()
    ).map(([program, count]) => ({
      program,
      count,
    }));

    // 6. Active Sessions (from lstClassSchedules)
    this.stats.activeSessions = this.lstClassSchedules.filter((schedule) => {
      const startTime = new Date(
        `${schedule.Date__c}T${schedule.Start_Time__c}`
      );
      const endTime = new Date(`${schedule.Date__c}T${schedule.End_Time__c}`);
      return now >= startTime && now <= endTime;
    }).length;

    // 7. Today's Sessions (from lstClassSchedules)
    this.stats.sessionsToday = this.lstClassSchedules.filter((schedule) => {
      const sessionDate = new Date(schedule.Date__c);
      return (
        sessionDate.getDate() === today.getDate() &&
        sessionDate.getMonth() === today.getMonth() &&
        sessionDate.getFullYear() === today.getFullYear()
      );
    }).length;

    // 8. Upcoming Classes (next 4 upcoming from lstClassSchedules) - UPDATED: Show total registered
    this.upcomingClasses = this.lstClassSchedules
      .filter((schedule) => {
        const sessionDate = new Date(
          `${schedule.Date__c}T${schedule.Start_Time__c}`
        );
        return sessionDate >= today;
      })
      .sort((a, b) => {
        const aDate = new Date(`${a.Date__c}T${a.Start_Time__c}`);
        const bDate = new Date(`${b.Date__c}T${b.Start_Time__c}`);
        return aDate.getTime() - bDate.getTime();
      })
      .slice(0, 4)
      .map((schedule) => {
        const program = this.lstPrograms.find(
          (p) => p.Id === schedule.Program__c
        );
        const registrations = this.lstRegistrationSchedules.filter(
          (reg) => reg.Class_Schedule__c === schedule.Id
        );

        // Get category name from Category object
        const category = this.lstCategories.find(
          (cat) => cat.Id === program?.Category_of_Program__c
        );

        return {
          time: this.formatSessionTime(
            `${schedule.Date__c}T${schedule.Start_Time__c}`
          ),
          program: program?.Name || "N/A",
          category: category?.Name || program?.Program_Catergory__c || "N/A",
          instructor: program?.Instructor__c || "N/A",
          students: registrations.length, // Total registered students
          capacity: schedule.Available_Spaces__c + registrations.length || 0,
          status: this.getSessionStatus(
            `${schedule.Date__c}T${schedule.Start_Time__c}`,
            this.calculateDuration(schedule.Start_Time__c, schedule.End_Time__c)
          ),
        };
      });

    // 9. Attendance Stats
    const todaySessions = this.lstClassSchedules.filter((schedule) => {
      const sessionDate = new Date(schedule.Date__c);
      return (
        sessionDate.getDate() === today.getDate() &&
        sessionDate.getMonth() === today.getMonth() &&
        sessionDate.getFullYear() === today.getFullYear()
      );
    });

    // Calculate present students from attendance records
    this.attendanceStats.todayPresent = this.lstAttendance.filter((att) => {
      const session = todaySessions.find((s) => s.Id === att.Class_Schedule__c);
      return session && att.Is_Absent__c === false;
    }).length;

    this.attendanceStats.todayTotal = todaySessions.reduce(
      (sum, session) =>
        sum +
        this.lstRegistrationSchedules.filter(
          (reg) => reg.Class_Schedule__c === session.Id
        ).length,
      0
    );

    this.attendanceStats.todayPercentage =
      this.attendanceStats.todayTotal > 0
        ? Math.round(
            (this.attendanceStats.todayPresent /
              this.attendanceStats.todayTotal) *
              100
          )
        : 0;

    // Calculate monthly average attendance
    const monthlySessions = this.lstClassSchedules.filter((schedule) => {
      const sessionDate = new Date(schedule.Date__c);
      return (
        sessionDate.getMonth() === currentMonth &&
        sessionDate.getFullYear() === currentYear
      );
    });

    const monthlyAttendance = monthlySessions.reduce(
      (sum, session) =>
        sum +
        this.lstRegistrationSchedules.filter(
          (reg) => reg.Class_Schedule__c === session.Id
        ).length,
      0
    );

    const monthlyCapacity = monthlySessions.reduce(
      (sum, session) =>
        sum +
        (session.Available_Spaces__c || 0) +
        this.lstRegistrationSchedules.filter(
          (reg) => reg.Class_Schedule__c === session.Id
        ).length,
      0
    );

    this.attendanceStats.monthlyAverage =
      monthlyCapacity > 0
        ? Math.round((monthlyAttendance / monthlyCapacity) * 100)
        : 0;

    // Weekly trend calculation
    this.attendanceStats.weeklyTrend = this.calculateWeeklyTrend();

    // Payment stats - FIXED: Proper calculation
    this.paymentStats.monthlyTotal = monthlySessions.reduce((sum, session) => {
      const program = this.lstPrograms.find((p) => p.Id === session.Program__c);
      const registrations = this.lstRegistrationSchedules.filter(
        (reg) => reg.Class_Schedule__c === session.Id
      ).length;
      const programFee = program?.Program_Fee__c || 0;
      return sum + programFee * registrations;
    }, 0);

    this.paymentStats.outstanding = monthlySessions.reduce((sum, session) => {
      const program = this.lstPrograms.find((p) => p.Id === session.Program__c);
      const availableSpaces = session.Available_Spaces__c || 0;
      const programFee = program?.Program_Fee__c || 0;
      return sum + programFee * availableSpaces;
    }, 0);

    // Monthly trend (Jan-current month) - FIXED: Proper calculation
    this.paymentStats.monthlyTrend = Array.from(
      { length: 12 },
      (_, monthIndex) => {
        return this.lstClassSchedules
          .filter((schedule) => {
            const sessionDate = new Date(schedule.Date__c);
            return (
              sessionDate.getMonth() === monthIndex &&
              sessionDate.getFullYear() === currentYear
            );
          })
          .reduce((sum, session) => {
            const program = this.lstPrograms.find(
              (p) => p.Id === session.Program__c
            );
            const registrations = this.lstRegistrationSchedules.filter(
              (reg) => reg.Class_Schedule__c === session.Id
            ).length;
            const programFee = program?.Program_Fee__c || 0;
            return sum + programFee * registrations;
          }, 0);
      }
    );
  }

  private calculateDuration(startTime: string, endTime: string): number {
    if (!startTime || !endTime) {
      return 60;
    }

    const start = new Date(`2000-01-01T${startTime}`);
    const end = new Date(`2000-01-01T${endTime}`);
    return (end.getTime() - start.getTime()) / (1000 * 60);
  }

  private calculateWeeklyTrend(): number[] {
    const now = new Date();
    const last7Days = Array.from({ length: 7 }, (_, i) => {
      const d = new Date();
      d.setDate(d.getDate() - 6 + i);
      return d;
    });

    return last7Days.map((day) => {
      const daySessions = this.lstClassSchedules.filter((schedule) => {
        const sessionDate = new Date(schedule.Date__c);
        return (
          sessionDate.getDate() === day.getDate() &&
          sessionDate.getMonth() === day.getMonth() &&
          sessionDate.getFullYear() === day.getFullYear()
        );
      });

      const present = this.lstAttendance.filter((att) => {
        const session = daySessions.find((s) => s.Id === att.Class_Schedule__c);
        return session && att.Is_Absent__c === false;
      }).length;

      const total = daySessions.reduce(
        (sum, session) =>
          sum +
          this.lstRegistrationSchedules.filter(
            (reg) => reg.Class_Schedule__c === session.Id
          ).length,
        0
      );

      return total > 0 ? Math.round((present / total) * 100) : 0;
    });
  }

  private formatSessionTime(dateString: string): string {
    const date = new Date(dateString);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const day = days[date.getDay()];
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    return `${day} ${formattedHours}:${minutes
      .toString()
      .padStart(2, "0")} ${ampm}`;
  }

  private getSessionStatus(dateString: string, duration: number): string {
    const now = new Date();
    const startTime = new Date(dateString);
    const endTime = new Date(startTime.getTime() + (duration || 60) * 60000);

    if (now < startTime) {
      return "Upcoming";
    }
    if (now >= startTime && now <= endTime) {
      return "In Progress";
    }
    return "Ended";
  }

  createProgramDistributionChart(): void {
    if (!this.programChartRef || this.stats.programDistribution.length === 0) {
      console.log("Program chart not available or no data");
      return;
    }

    try {
      const ctx = this.programChartRef.nativeElement.getContext("2d");

      // Destroy existing chart if it exists
      if (this.programChartRef.chart) {
        this.programChartRef.chart.destroy();
      }

      this.programChartRef.chart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: this.stats.programDistribution.map((p) => p.program),
          datasets: [
            {
              data: this.stats.programDistribution.map((p) => p.count),
              backgroundColor: [
                "#3b82f6",
                "#10b981",
                "#8b5cf6",
                "#f59e0b",
                "#ef4444",
                "#06b6d4",
                "#8b5cf6",
              ],
              borderWidth: 2,
              borderColor: "#fff",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "right",
              labels: {
                usePointStyle: true,
                padding: 15,
              },
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const label = context.label || "";
                  const value = Number(context.raw) || 0;
                  const total = context.dataset.data.reduce(
                    (a: number, b: number) => a + b,
                    0
                  );
                  const percentage = Math.round((value / total) * 100);
                  return `${label}: ${value} (${percentage}%)`;
                },
              },
            },
          },
        },
      });
    } catch (error) {
      console.error("Error creating program chart:", error);
    }
  }

  createAttendanceChart(): void {
    if (
      !this.attendanceChartRef ||
      this.attendanceStats.weeklyTrend.length === 0
    ) {
      console.log("Attendance chart not available or no data");
      return;
    }

    try {
      const ctx = this.attendanceChartRef.nativeElement.getContext("2d");

      // Destroy existing chart if it exists
      if (this.attendanceChartRef.chart) {
        this.attendanceChartRef.chart.destroy();
      }

      this.attendanceChartRef.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          datasets: [
            {
              label: "Attendance %",
              data: this.attendanceStats.weeklyTrend,
              borderColor: "#3b82f6",
              backgroundColor: "rgba(59, 130, 246, 0.1)",
              fill: true,
              tension: 0.4,
              pointBackgroundColor: "#3b82f6",
              pointBorderColor: "#fff",
              pointBorderWidth: 2,
              pointRadius: 4,
              pointHoverRadius: 6,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              min: 0,
              max: 100,
              ticks: {
                callback: function (value) {
                  return value + "%";
                },
              },
              grid: {
                color: "rgba(0, 0, 0, 0.1)",
              },
            },
            x: {
              grid: {
                color: "rgba(0, 0, 0, 0.1)",
              },
            },
          },
          plugins: {
            tooltip: {
              callbacks: {
                label: function (context) {
                  return context.parsed.y + "% attendance";
                },
              },
            },
          },
        },
      });
    } catch (error) {
      console.error("Error creating attendance chart:", error);
    }
  }

  createPaymentsChart(): void {
    if (!this.paymentsChartRef || !this.paymentStats?.monthlyTrend) {
      console.log("Payments chart not available or no data");
      return;
    }

    try {
      const ctx = this.paymentsChartRef.nativeElement.getContext("2d");

      // Destroy existing chart if it exists
      if (this.paymentsChartRef.chart) {
        this.paymentsChartRef.chart.destroy();
      }

      const allMonths = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthlyData = [...this.paymentStats.monthlyTrend];

      this.paymentsChartRef.chart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: allMonths,
          datasets: [
            {
              label: "Payments ($)",
              data: monthlyData,
              backgroundColor: "#10b981",
              borderRadius: 6,
              borderSkipped: false,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: function (value) {
                  return "$" + value;
                },
              },
              suggestedMax: Math.max(...monthlyData) * 1.2,
            },
            x: {
              grid: {
                display: false,
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  return "$" + context.parsed.y.toLocaleString();
                },
              },
            },
          },
        },
      });
    } catch (error) {
      console.error("Error creating payments chart:", error);
    }
  }
}
